module.exports = __webpack_public_path__ + "img/galet_basalte.77627e75.jpg";